import { RootState } from 'app/redux/state/root-state';

export const selectIsAuthenticated = (state: RootState): boolean => !!state.auth.authToken;
